export default __webpack_public_path__ + "static/media/user-icon.ec88091a.svg";